import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import React from 'react';
import { useVisibleButton } from '../../../../hooks/shared/quests/useVisibleButton';
import { useButtonAttribute } from '../../../../hooks/shared/quests/useButtonAttribute';
import { useQuestFlags } from '../../../../hooks/shared/quests/useQuestFlags';
import { useClickOnQuestButton } from '../../../../hooks/shared/quests/useClickOnQuestButton';
import { useApplicationCallbacks } from '../../../../providers/application-callbacks';

export default function TaskItemButton({ quest, taskCallback }) {
  const isVisibleButton = useVisibleButton({ quest });
  const buttonAttr = useButtonAttribute({ quest });
  const { isChallenge } = useQuestFlags({ quest });
  const callbacks = useApplicationCallbacks();
  const clickOnQuest = useClickOnQuestButton({ callbacks, quest, taskCallback });

  return (
    isVisibleButton && (
      <CustomButton
        {...(buttonAttr ?? {})}
        className={classNames('button_task', 'task__item-button', {
          'custom-button_challenge': isChallenge,
          [`task__item-button_${buttonAttr?.btnMod}`]: buttonAttr?.btnMod && isChallenge,
        })}
        onClick={clickOnQuest}
      />
    )
  );
}
